import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

// Étincelle PLEINE à 4 branches (twinkle), couleur configurable depuis le thème.
export function Sparkle({ size = 14, color, style }: { size?: number; color: string; style?: StyleProp<ViewStyle> }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" style={style} pointerEvents="none">
      <Path
        fill={color}
        d="M12 0 C12.8 7 17 11.2 24 12 C17 12.8 12.8 17 12 24 C11.2 17 7 12.8 0 12 C7 11.2 11.2 7 12 0 Z"
      />
    </Svg>
  );
}
